import React from "react";

class ProfileMain extends React.Component {
  render() {
    return <div>profile</div>;
  }
}

export default ProfileMain;
